'use strict';
var Fp = require('fp/app');
const helpers = require('../common/helpers');

module.exports = class ft extends Fp {
	constructor(config) {
		super()
		this.config = config;
		this.itemsRub = document.querySelectorAll('.ft__nav li');
		this.libelleSessionStorageSubMenu = 'ftSubmenu';
	}
	initialize(settingsFT) {
		let self = this;

		/// Gestion du sommaire de chaque rubrique
		this.sommaire(settingsFT.classFT);

		/// On clique sur un item de la popin
		this.event();

		/// settingsFT.rub = item de la rubrique cliqué
		this.tab(settingsFT.rub);

		/// Download PDF FT
		if (helpers.elementExist('.ft__footer [data-download]')) {
			document.querySelector('.ft__footer [data-download]').addEventListener('click', function (e) {
				const {
					target
				} = e;

				self.downloadFT(target, settingsFT.classFT);
			})
		}
		let params = new URLSearchParams(document.location.search);
		let name = params.get('ft');

		if (name != null && document.getElementById(name)) {
			document.getElementById(name).scrollIntoView()
		}
	}

	set openSubmenu(slug) {
		window.sessionStorage.setItem(this.libelleSessionStorageSubMenu, slug);
	}
	get getOpenSubmenu() {
		return window.sessionStorage.getItem(this.libelleSessionStorageSubMenu);
	}

	/**
	 * On clone le sommaire de chaque rubrique dans <aside>
	 * @param {string} classFT 
	 */
	sommaire(classFT) {
		const templatesMenu = document.querySelectorAll(`.${classFT} template`);
		for (const element of templatesMenu) {
			const clone = document.importNode(element.content, true);
			/// On définit le block dans lequel on va ajouter le sommaire
			let block = document.querySelector(`.${classFT} aside`);
			block.appendChild(clone);
		}
	}

	/**
	 * Au click, on affiche ou le sous-menu ou la rubrique de la FT
	 */
	event() {
		let self = this;
		// Click item popin FT
		document.body.addEventListener('click', function (e) {
			const {
				target
			} = e;

			if (target.dataset.ft === 'ftRubrique') {
				let slug = target.dataset.ftRubrique;
				self.openSubmenu = slug;

				if (helpers.getWindowWidth() > 1023) {
					document.querySelectorAll('menu[data-rub]').forEach(el => el.hidden = true);
				} else {
					if (e.target.parentElement.className.includes('is-active')) {
						document.querySelector(`menu[data-rub="${slug}"]`).hidden = !document.querySelector(`menu[data-rub="${slug}"]`).hidden;
						document.querySelector('.lightbox--ft').classList.toggle('has-open-menu');

						if (helpers.offset(e.target.parentElement).left > 11) {
							document.querySelector(`menu[data-rub="${slug}"]`).style.borderTopLeftRadius = getComputedStyle(document.querySelector(`menu[data-rub="${slug}"]`)).borderEndEndRadius;
							document.querySelector(`menu[data-rub="${slug}"]`).style.borderTopRightRadius = 0;
						}
					}
				}

				self.tab(slug);

				document.querySelector(`.ft__rubrique`).scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});

			} else if (target.dataset.remove === '#formDownloadFT') {
				self.removeFormDownloadPDF()
			} else if (target.hash !== undefined) {

				if (helpers.getWindowWidth() < 1024) {
					document.querySelector(`menu[data-rub="${self.getOpenSubmenu}"]`).hidden = true;
					document.querySelector('.lightbox--ft').classList.remove('has-open-menu');
				}


			} else if (target.dataset.download === '/Produit/DemandePDFFicheProduit/') {
				if (document.querySelector('.lightbox--ft') !== null) {
					document.querySelector('.lightbox--ft').classList.add('has-open-menu');
				} else {
					document.body.classList.add('has-overlay')
				}
			} else if (document.querySelector('.lightbox--ft') !== null) {
				if (document.getElementById(self.pdfFT.idContainer) === null) {
					document.querySelector('.lightbox--ft').classList.remove('has-open-menu');
					if (helpers.getWindowWidth() < 1024) {
						document.querySelectorAll('menu[data-rub]').forEach(el => el.hidden = true);
					}
				} else if (target.type !== 'email' && target.type !== 'submit' && target.localName !== 'box-rgpd') {
					self.removeFormDownloadPDF();
				}
			}
		})
	}
	/**
	 * Sur mobile, on scrolle l'item de nav et on l'active
	 * @param {string} item 
	 */
	tab(item) {
		/// À l'ouverture
		let callback = function () {
			if (helpers.getWindowWidth() < 1024) {
				document.querySelector(`[data-ft-rubrique="${item}"]`).parentElement.scrollIntoView({
					behavior: 'smooth',
					inline: 'start'
				});
			}
			document.querySelectorAll('.ft__rubrique > div').forEach(element => {
				if (element.id === item) {
					element.hidden = false;
				} else {
					element.hidden = true;
				}
			})
			if (helpers.getWindowWidth() > 1023) {
				document.querySelector(`menu[data-rub="${item}"]`).hidden = !document.querySelector(`menu[data-rub="${item}"]`).hidden;
			}

		}
		helpers.setActiveItemInactiveSiblings(this.itemsRub, document.querySelector(`[data-ft-rubrique="${item}"]`).parentElement, callback)
	}

	/**
	 * Méthode pour supprimer le block de demande de FT
	 */
	removeFormDownloadPDF() {
		document.body.classList.remove('has-overlay');
		document.querySelector('.lightbox--ft').classList.remove('has-open-menu');
		document.getElementById(this.pdfFT.idContainer).remove();
	}
}